import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { FiltersState, Filter } from '../store/store'
import { Params } from '../../types'
import { useTranslation } from 'react-i18next'
import FilterPanel from '../../../components/layout/FilterPanel'
import './SubscriptionsFilterPanel.css'

type Props = {
  currentFilterId: string | null
  filters: FiltersState
}

function SubscriptionsFilterPanel(props: Props) {
  const { filters, currentFilterId } = props
  const history = useHistory()
  const { partnerId } = useParams() as Params
  const { t } = useTranslation(['subscriptions', 'global'])

  function selectFilter(filterId: string) {
    history.push(`/partner/${partnerId}/subscriptions?filter=${filterId}`)
  }

  function clearFilter() {
    history.push(`/partner/${partnerId}/subscriptions`)
  }

  return (
    <FilterPanel>
      {filters.filters.length === 0 && (
        <div className="padding-m">
          {t('no_filters')}
        </div>
      )}

      {currentFilterId && (
        <div className="clear-container">
          <div className="pill" id="clear-filter-btn" onClick={clearFilter}>
            <i className="fas fa-times icon-spacing"></i>
            <span>{t('global:clear')}</span>
          </div>

        </div>
      )}

      {filters.filters.map((filter: Filter) => (
        <div className="filter-item-outer" key={filter.id} onClick={() => selectFilter(filter.id)}>
          <div className="filter-item" >
            <div>
              {filter.id === currentFilterId && (
                <i className="fas fa-filter filter-icon-small"></i>
              )}
            </div>
            <div>{filter.name} ({filter.subscription_count})</div>
          </div>
        </div>
      ))}
    </FilterPanel>
  )
}

export default SubscriptionsFilterPanel
